import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MenuItemAdvanced, OrganizationService } from '@boma/client-shared';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../../../apps/website/src/environments/environment';
import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { AppComponent } from 'apps/supplier-portal/src/app/app.component';

interface selectedLink {
  label: string;
  route: string;
  iconClass: string;
  buttonClass: string;
}
@Component({
  selector: 'website-menu',
  templateUrl: './website-menu.component.html',
  styleUrls: ['./website-menu.component.scss'],
})
export class WebsiteMenuComponent implements OnInit, OnChanges {
  organization$: Observable<any>;
  organizationSubscription: Subscription;

  loaded = false;

  @Output() login = new EventEmitter();
  @Output() logout = new EventEmitter();
  @Output() contextChanged = new EventEmitter<{
    entityId: string;
    locationId: string;
  }>();
  @Output() handleMenuButtonClick = new EventEmitter();

  @Input() topBarNotificationMenuActive;
  @Input() username: string | null = null;
  @Input() checkedUsername: boolean = true; // using this cause I need to resolve the error where users if they ever see a login button flash on the screen they get confused.
  @Input() profile: any | null = null; // any because of where shared type
  @Input() locations: any[] | null = null; // any because of where shared type
  @Input() cartData: any | null = null; // any because of where shared type
  @Input() activeLocationId: string | null = null;
  @Input() activeEntityId: string | null = null;
  @Input() module = 'website';
  @Input() logo = '/assets/layout/images/brand/logo-h-dark-text.svg';
  @Input() scope = '';
  @Input() menuItems: MenuItemAdvanced[] = [
    {
      label: 'Home',
      routerLink: ['/'],
    },
    {
      label: 'Shopping',
      routerLink: ['/', 'storefront'],
    },
    {
      label: 'Marketplace',
      routerLink: ['/', 'marketplace'],
      items: [
        { label: "Who's Buying" },
        { label: "Who's Selling" },
        { label: 'Marketfeed' },
      ],
    },
    {
      label: 'Business Owner',
      routerLink: ['/', 'trader'],
    },
    {
      label: 'Supplier',
      routerLink: ['/', 'supplier'],
    },
    {
      label: 'Producer',
      routerLink: ['/', 'producer'],
    },
    {
      label: 'Shopper',
      routerLink: ['/', 'shoppers'],
    },
    {
      label: 'About',
      items: [
        { label: 'We are BoMa', routerLink: ['/', 'about-boma'] },
        { label: 'The Boma Team', routerLink: ['/', 'the-boma-team'] },
        { label: 'Careers', routerLink: ['/', 'careers'] },
        { label: 'Contact', routerLink: ['/', 'contact'] },
      ],
    },
    {
      label: 'News',
      routerLink: ['/', 'blog'],
    },
  ];

  displaySwitchContextDialog = false;
  displayUpdateDefaultAccountDialog = false;
  entityOption: string | null;
  entityOptions: { label: string; value: string }[];
  locationOption: string | null;
  locationOptions: { label: string; value: string }[];
  cartButtonLabel: string;
  defaultAccount: { label: string; value: string };
  items: MenuItemAdvanced[];
  loginItems: MenuItemAdvanced[];
  selectedEntity = '';
  selectedLocation = '';
  defaultEntity: any;
  defaultLocation: any;
  userSelectedPoints = [];
  supplierURL: string = environment.supplierRoute;
  websiteRoute: string = environment.websiteRoute;
  noEntities = null; // It should be impossible for a user to have no entities... as we create a default one when you sign up.
  appMain: AppComponent;

  links: selectedLink[] = [
    {
      label: 'My Business',
      route: this.supplierURL,
      iconClass: 'material-icons-round mi-point-of-sale',
      buttonClass: 'my-business',
    },
    {
      label: 'Shopping',
      route: this.websiteRoute + 'shopping',
      iconClass: 'material-icons-round mi-shopping-bag',
      buttonClass: 'shopping',
    },
    {
      label: 'Marketplace',
      route: this.websiteRoute + 'marketplace',
      iconClass: 'material-icons-round mi-storefront',
      buttonClass: 'marketplace',
    },
  ];

  selectedLink: selectedLink;

  constructor(
    private organizationService: OrganizationService,
    private store: Store,
    private injector: Injector
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.profile && changes.profile.currentValue) {
      this.username =
        changes.profile.currentValue.firstName +
        ' ' +
        changes.profile.currentValue?.surname;
      //When we change the profile
      this.entityOptions = changes.profile.currentValue.entities.map((x) => ({
        label: x.name,
        value: x.id,
      }));

      // TODO This logic is faulty now as the account will be named something else
      // I guess we can find it by the weird zambian coords
      this.defaultEntity = this.entityOptions.find(
        (x) => x.label === 'My Account'
      );
    }

    if (changes.activeEntityId && changes.activeEntityId.currentValue) {
      // console.log('active entity', changes?.activeEntityId?.currentValue);
      this.entityOption = changes.activeEntityId.currentValue;
      //Find selected entity name and set it

      this.selectedEntity = changes.profile.currentValue.entities
        .filter((x) => x.id === changes.activeEntityId.currentValue)
        .map((x) => x.name);

      localStorage.setItem('selectedEntityId', this.entityOption);
    }
    if (changes.activeLocationId && changes.activeLocationId.currentValue) {
      this.locationOption = changes.activeLocationId.currentValue;

      this.selectedLocation = changes?.locations?.currentValue
        .filter((x) => x.id === changes.activeLocationId.currentValue)
        .map((x) => x.name);
    }

    if (changes.locations && changes.locations.currentValue) {
      // when we change locations
      this.locationOptions = changes.locations.currentValue
        .filter((x) => x.type === 'Physical') // makes no sense for vehicles to be on the website
        .map((x) => ({
          label: x.name,
          value: x.id,
        }));

      if (
        this.locationOptions.filter((l) => l.value === this.activeLocationId)
          .length
      ) {
        this.locationOption = this.activeLocationId;
      } else if (this.locationOptions.length) {
        this.locationOption = this.locationOptions[0].value;
      }

      if (this.defaultEntity) {
        this.defaultLocation = changes?.locations?.currentValue.find(
          (x) => x.name === 'Home'
        );
        //console.log(this.defaultLocation); // undefined @TODO

        if (
          // [25.998464226722717, -15.012723107549133]
          Math.round(this.defaultLocation?.point.coordinates[0]) === 26 &&
          Math.round(this.defaultLocation?.point.coordinates[1]) === -15 &&
          this.defaultLocation.usageType === 'Receiving'
        )
          this.displayUpdateDefaultAccountDialog = true;
      }
    }
    if (changes?.cartData && changes?.cartData.currentValue) {
      this.cartButtonLabel =
        changes.cartData.currentValue.count > 0
          ? changes.cartData.currentValue.count
          : '0';
    }
  }

  ngOnInit(): void {
    this.appMain = <AppComponent>this.injector.get(AppComponent, null);

    this.store
      .select(getSelectedOrganizationInfo)
      .pipe(take(1))
      .subscribe((org) => {
        if (org) {
          this.entityOption = org.id;
          this.loaded = true;
        } else {
          this.loaded = true;
        }
      });

    this.loginItems = [
      {
        label: 'My Business',
        command: () => {
          window.location.href = environment.supplierRoute;
        },
      },
    ];

    if (this.scope === 'portal') {
      this.loginItems.push({
        label: 'My Account',
        command: () => {
          window.location.href = '/my-account';
        },
      });
    }

    this.loginItems.push(
      { separator: true },
      {
        label: 'Log Out',
        command: () => {
          this.logout.emit();
        },
      }
    );
  }

  emitLogin() {
    this.login.emit();
  }

  navigate(e) {
    if (e === 'my-business') {
      window.location.href = environment.supplierRoute;
    } else {
      // window.location.href = environment.supplierRoute;
      window.open(e, '_blank');
      if (this.scope === 'portal') {
        this.selectedLink = this.links.find(
          (x) => x.buttonClass === 'my-business'
        );
      }
    }
  }

  handleEntityOptionChanged() {
    this.locationOption = null;
    this.locationOptions = [];
    this.contextChanged.emit({
      entityId: this.entityOption,
      locationId: this.locationOption,
    });
  }

  handleContextChanged() {
    this.contextChanged.emit({
      entityId: this.entityOption,
      locationId: this.locationOption,
    });
    this.displaySwitchContextDialog = false;
  }

  handleUpdateDefault() {
    this.organizationService
      .updateLocation(this.defaultEntity.value, this.defaultLocation.id, {
        ...this.defaultLocation,
        usageType: 'Receiving',
        point: { coordinates: this.userSelectedPoints },
        updateCountryByCoordinates: true,
        isHeadOffice: true,
      })
      .subscribe((x) => {
        this.displayUpdateDefaultAccountDialog = false;
      });
  }

  handleSetLocation(point) {
    //console.log(point);
    this.userSelectedPoints = point;
  }
}
